module.exports = __webpack_public_path__ + "static/media/process_gray.31ea1d53.svg";